import { render, staticRenderFns } from "./definitive.vue?vue&type=template&id=144be8d0"
import script from "./definitive.vue?vue&type=script&lang=js"
export * from "./definitive.vue?vue&type=script&lang=js"
import style0 from "./definitive.vue?vue&type=style&index=0&id=144be8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports